import RootModal from './RootModal';

export default RootModal;
